import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

function ConfirmDeleteModal({
  title,
  descr,
  onClose,
  onDelete,
  applyLabel,
  loadingLabel,
  requireConfirmation = false,
  blockedContent,
  checking = false,
}) {
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);

  const handleDelete = async () => {
    if (requireConfirmation && !confirmed) return;

    setLoading(true);
    try {
      await onDelete();
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const canDelete = (!requireConfirmation || confirmed) && !loading && !checking && !blockedContent;

  return (
    <Dialog open onClose={loading ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6, position: "relative" }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <WarningIcon color="warning" sx={{ mr: 1 }} />
          <Typography fontSize={22} fontWeight={500} color="text.primary">
            {title}
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          disabled={loading}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {blockedContent || (
          <Alert severity="warning" icon={false} sx={{ mb: 3, "& .MuiAlert-message": { width: "100%", textAlign: "center" } }}>
            {descr}
          </Alert>
        )}

        {requireConfirmation && !loading && !blockedContent && (
          <Box display="flex" justifyContent="center">
            <FormControlLabel
              control={
                <Checkbox
                  checked={confirmed}
                  onChange={(e) => setConfirmed(e.target.checked)}
                  color="primary"
                />
              }
              label="I understand this action cannot be undone"
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          data-id="confirm-delete"
          variant="contained"
          color="primary"
          onClick={handleDelete}
          disabled={!canDelete}
        >
          {loading ? loadingLabel || "Deleting..." : applyLabel || "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDeleteModal;
